'use server';

import { SessionService } from '@/contexts/authentication';
import type { AudioStory } from '@/contexts/audio-stories/types';

export async function getAudioStoriesByStory(storyId: string): Promise<AudioStory[]> {
  const familyId = await SessionService.getFamilyId();
  if (!familyId) return [];

  const { getAudioStoryRepository } = await import('@/contexts/audio-stories/repositories');
  return getAudioStoryRepository().getByStoryId(storyId, familyId);
}
